import { useCallback } from 'react';
import toast from 'react-hot-toast';

export interface ToastProps {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

export function useToast() {
  const toastFn = useCallback(
    ({ title, description, variant = 'default' }: ToastProps) => {
      const variantClass = variant === 'destructive' ? 'destructive' : 'default';
      
      return toast.custom(
        (t) => (
          <div
            className={`
              ${t.visible ? 'animate-in fade-in-80' : 'animate-out fade-out-80'}
              max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto overflow-hidden
              ${variantClass === 'destructive' ? 'border-red-600' : 'border-gray-200'}
              border
            `}
          >
            <div className="p-4">
              {title && <div className="font-medium">{title}</div>}
              {description && <div className="text-sm opacity-90 mt-1">{description}</div>}
            </div>
          </div>
        ),
        { duration: 3000 }
      );
    },
    []
  );

  return {
    toast: toastFn,
  };
} 